// 根据电脑来判断语言
module.exports = {
	myCard: {
		loginfirst: '请先登录游戏账号',
		gotogame: '登录',
		gamename: '猫之城-充值中心', //catfantasy-payment 貓之城-儲值中心 チャージセンター『キャットファンタジ―』 캣 판타지-상점
		titleAccount: '账号信息',
		account: '账号',
		activeAccount: '当前账号',
		password: '密码',
		titlePayWay: '充值管道',
		titlePayAccount: '充值金额',
		titlePayList: '宝石售价表',
		myCardPoint: 'MyCard点数',
		myCardGiftNum: '宝石（个）',
		submit: '提 交',
		change: '进行充值兑换',
		logout: '退出',
		gameRole: '角色',
		noGameRole: '暂无绑定游戏角色,请切换账号重试',
		point: '点',
		cardNum: '卡号',
		cardPass: '卡密',
		placeholderCardNum: '请输入卡号',
		placeholderCardPass: '请输入密码',
		extraGift: '额外赠送',
		time: '倒计时',
		timeout: '已截止',
		payWay1: '钱包扣点',
		payWay2: '点数卡',
		payWay3: '会员扣点',
		payWay4: '卡片充值',
		secTitle1: '活动专属',
		secTitle2: '超值回馈',
		secTitle3: '独家优惠',
		secTitle4: '常驻商店',
		failed: '操作失败',
		tip: '请注意：官网充值不享有首储奖励及赠猫眼石特权。',
		days: '天',
		pay1: '请尽快完成付款',
		pay2: '已完成付款',
		pay3: '未查询到结果',
		pay4: '若已完成支付，稍后请在游戏内查收',
		pay5: '稍后请在游戏内查收',
		loginFirst: '请先登录游戏账号',
		extraSend: '额外赠：',
		extraTitle: '自订猫眼石数量',
		stock: '库存：',
		otherNum: '其他数量',
		chooseCoupon: '选择优惠券',
		loginTips: '完成登录后可查看',
		noCoupon: '暂无可用优惠券',
		expireAt: '有效期至：',
		disCount: 'off',
		useType: '滿{amount}可用',
		proInfo: '商品信息：',
		proNum: '商品数量：',
		roleInfo: '角色信息：',
		proPrice: '商品原价：',
		disCountPrice: '折扣金额：',
		totalPrice: '合计：',
		inputNum: '输入充值数量',
		extraTips:
			'说明：输入充值数量必须大于6480，且为10的倍数，单次最多不超过99990',
		chooseRole: '角色选择',
		maxNum: '最高抵扣',
		couponTips:
			'您有一笔正在付款的订单中使用了优惠券，请问是否要取消订单退还优惠券？',
		couponTips2: '',
		useCoupon: '使用的优惠券：',
		originalAmount: '商品原价：',
		productSubject: '商品信息：',
		payAmount: '付款金额：',
		couponBtn1: '取消并退还优惠券',
		couponBtn2: '继续付款上笔订单',
		closeMyCard: '关闭当前页面',
		empty: '若要查看商品，请先登录游戏账号~',
		coupon: '优惠券',
		check: '查看',
		orderTitle: '确认付款订单',
		checkCoupon: '查看优惠券',
		orderCancel: '订单已取消',
		orderListTitle: '网页付款记录查询',
		orderListSecTitle: '最多支持查询一年内记录',
		orderListEmpty: '暂无购买记录',
		orderListPayWay: '付款',
		orderListPayTime: '付款时间:',
		orderListCreateTime: '下单时间:',
		orderListNum: '订单号:',
		orderListExtra: '包含VAT',
		orderListCloseTime: '订单关闭倒数计时:',
		orderListClose: '取消付款',
		orderListPay: '前往付款',
		loadMore: '查看更多',
		orderTab1: '全部',
		orderTab2: '未付款',
		orderTab3: '已付款',
		orderTab4: '已取消',
		orderTab5: '订单关闭',
		navHome: '首页',
		navMyOrder: '我的订单',
		exchangeCoupon: '兑换优惠券',
		exchangeTip: '请输入兑换码',
		exchangeCode: '兑换码:',
		exchangeCodeTip: '请输入兑换码(16位大写字母+数字)',
		exchange: '兑换',
		hasCoupon: '恭喜你获得优惠券！ ',
		checkExchangeCoupon: '查看/兑换优惠券',
		share: '可疊加',
		payTitle: '确认订单',
		isFirst: '首充奖励',
	},
	payRule: {
		title: '充值说明',
		text1: '1.购买时请务必再次确认您所输入的交易咨询，商品交易成功后，将无法转移至其他账号。',
		text2: '2.购买完成后，商品将依照当日连线状况入帐，需要时间最少5分钟、至多40分钟。如有限时优惠活动，请于活动结束时间前一小时完成购买程序，以免物品进帐时计算到隔日天数。',
		text3: '3.有任何疑问，请来信客服询问，客服邮箱：catcs.contact@gmail.com，处理时间约3-5工作天。',
		text4: '',
		text5: '',
		text6: '',
	},
	final: {
		success: '交易成功',
		failed: '交易失败',
		goBack: '返回首页',
		tips: '奖励已发放，请至游戏内的邮件领取',
	},
	rule: {
		title: '注意事项',
		text1: '1.购买时请务必再次确认您所输入的交易咨询，商品交易成功后,将无法转移至其他账号。。',
		text2: '2.购买完成后，商品将依照当日连线状况入账，需要时间最少5分钟、至多40分钟。如有限时优惠活动，请于活动结束时间前一小时完成购买程序，以免物品进账时计算到隔日天数。',
		text3: '3.有任何疑问，请来信客服询问，客服邮箱：game,.billing@so-net.net.tw，处理时间约3-5工作天。',
		text4: '4.目前港澳地区仅开放使用MyCard、Gash两种充值卡。',
		text5: '5.可充值的点数卡面额，请以官方在平台上公布的面额为主，若平台上无此面额，将无法充值成功，官方也无法进行退款哦！',
		text6: '6.目前GASH+实体礼物卡、GASH电子钱包、MyCard电子钱包等不适用于此平台充值，请您特别留意，若购买错误导致无法充值，官方将无法受理，要麻烦您向GASH或MyCard办理后续作业。',
	},
	pay: {
		title: '确认订单',
	},
	uidText: {
		tx1: '请输入游戏id验证',
		tx2: '登录',
		tx3: '游戏内绑定账号可获得优惠卷福利!',
		tx4: 'まずはアカウントにログインしてください',
	},
};
